<div class="container chart">
    <canvas baseChart
        [datasets]="ChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [chartType]="ChartType"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
    </canvas>
</div>
